import React from "react";
import "./InputOutlined.scss";

const InputOutlined = (props) => {
  const isInvalid =
    props.isInvalid && props.isInvalid.length ? props.isInvalid : undefined;

  const isValid = props.isValid ? " isValid" : "";

  return (
    <React.Fragment>
      {props.title && (
        <span className={!isInvalid ? "labelInput" : "labelInput errorLabel"}>
          {props.title}
        </span>
      )}
      <input
        className={
          isInvalid ? "outlinedInput errorInput" : "outlinedInput" + isValid
        }
        placeholder={props.placeholder}
        onChange={props.onChange}
        aria-label={props.ariaLabel}
        value={props.value}
        type={props.type || "text"}
        name={props.name}
        autoComplete={props.autoComplete}
        defaultValue={props.selected || props.defaultValue}
        disabled={props.isDisabled}
      />
      {isInvalid ? <span className="errorText">{isInvalid}</span> : null}
    </React.Fragment>
  );
};

export default InputOutlined;
